import { render, staticRenderFns } from "./GoldBeanListDeduction.vue?vue&type=template&id=62be45fc&scoped=true&"
import script from "./GoldBeanListDeduction.vue?vue&type=script&lang=ts&"
export * from "./GoldBeanListDeduction.vue?vue&type=script&lang=ts&"
import style0 from "./GoldBeanListDeduction.vue?vue&type=style&index=0&id=62be45fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be45fc",
  null
  
)

export default component.exports